import { baseUrlForTT, getOptions } from "../utilities/metricsConfig";
import axios from "axios";

class TTMetricsService {
  constructor(baseUrl) {
    this.basePath = "/";
    this.baseUrl = `${baseUrl}${this.basePath}`;
  }

  getMetrics(line, parameters) {
    return axios(
      getOptions(this.baseUrl, `model/description/line/${line}`, parameters)
    );
  }
}

const ttMetricsService = new TTMetricsService(baseUrlForTT);

export default ttMetricsService;
